<template>
  <div>
    <div class="cstm-tab-holder">
      <div
        class="cstm-unique-tab flex mb-4"
        :class="{ disableTabName: kanbanShow }"
      >
        <div style="width: calc(100% - 105px)" class="flex flex-wrap">
          <div
            v-if="taskViewPermission"
            class="tab-name"
            :class="{ activeTab: task }"
            @click="tab('task')"
          >
            Live Tasks
          </div>
          <div
            v-if="projectViewPermission"
            class="tab-name disableTab"
            :class="{ activeTab: projects }"
            @click="tab('projects')"
          >
            Projects
          </div>
          <div
            v-if="taskViewPermission"
            class="tab-name disableTab"
            :class="{ activeTab: template }"
            @click="tab('template')"
          >
            Templates
          </div>
        </div>
      </div>

      <vs-card class="cstm_vx_card mb-4" v-if="task && taskViewPermission">
        <div slot="header" class="flex justify-between">
          <h4>Select View</h4>
        </div>
        <vs-row>
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-row>
              <vs-col vs-lg="2" vs-sm="12" vs-xs="12" class="p-1">
                <vs-input
                  placeholder="Search"
                  class="w-full"
                  v-model="search"
                  @keyup="searchFun"
                  style="width: 100%"
                />
              </vs-col>
              <vs-col vs-lg="2" vs-sm="12" vs-xs="12" class="p-1">
                <date-range-picker
                  class="w-full cstm_daterangepicker h-full"
                  ref="picker"
                  :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm' }"
                  :showWeekNumbers="true"
                  :showDropdowns="true"
                  :ranges="customDateRanges()"
                  v-model="dateRange"
                >
                  <template v-slot:input="picker" style="min-width: 350px">
                    <span
                      v-if="
                        dateRange.startDate === '' || dateRange.endDate === ''
                      "
                      style="
                        color: rgba(0, 0, 0, 0.5);
                        font-weight: 400;
                        font-size: 12px;
                      "
                      >Select Date Range</span
                    >
                    <span v-else
                      >{{ picker.startDate | date }} -
                      {{ picker.endDate | date }}</span
                    >
                  </template>
                </date-range-picker>
              </vs-col>
              <vs-col
                vs-lg="2"
                vs-sm="12"
                vs-xs="12"
                class="p-1"
                v-if="!kanbanShow"
              >
                <v-select
                  v-model="task_status_id"
                  :reduce="option => option.id"
                  label="status"
                  name="status"
                  :options="options"
                  placeholder="Filter Status"
                />
              </vs-col>
              <vs-col vs-lg="2" vs-sm="12" vs-xs="12" class="p-1">
                <v-select
                  v-model="taskResponsiblePersonUser"
                  :reduce="option => option.id"
                  label="label"
                  name="first_name"
                  :options="userList"
                  placeholder="Staff responsible person"
                  @open="onOpenUser"
                  @close="onCloseUser"
                >
                  <template v-slot:selected-option="userList">
                    <img
                      v-if="userList.picture"
                      class="person-img rounded-full"
                      :src="userList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ userList.first_name }}
                    {{ userList.last_name }}
                  </template>
                  <template v-slot:option="userList">
                    <img
                      v-if="userList.picture"
                      class="person-img rounded-full"
                      :src="userList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ userList.first_name }}
                    {{ userList.last_name }}
                  </template>
                  <template #list-footer>
                    <li
                      ref="load"
                      class="loader"
                      v-show="userListMeta.has_next"
                    >
                      Loading more staff...
                    </li>
                  </template></v-select
                >
              </vs-col>
              <vs-col vs-lg="2" vs-sm="12" vs-xs="12" class="p-1">
                <v-select
                  v-model="taskResponsiblePersonClientUser"
                  :reduce="option => option.client_users_id"
                  label="label"
                  name="first_name"
                  :options="clientList"
                  placeholder="Student responsible person"
                  @open="onOpen"
                  @close="onClose"
                >
                  <template v-slot:selected-option="clientList">
                    <img
                      v-if="clientList.picture"
                      class="person-img rounded-full"
                      :src="clientList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ clientList.first_name }}
                    {{ clientList.last_name }}
                  </template>
                  <template v-slot:option="clientList">
                    <img
                      v-if="clientList.picture"
                      class="person-img rounded-full"
                      :src="clientList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ clientList.first_name }}
                    {{ clientList.last_name }}
                  </template>
                  <template #list-footer>
                    <li
                      ref="loadStudent"
                      class="loader"
                      v-show="clientListMeta.has_next"
                    >
                      Loading more student...
                    </li>
                  </template></v-select
                >
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-lg="2"
                vs-sm="12"
                vs-xs="12"
                class="p-1"
              >
                <vs-button
                  class="includeIcon includeIconOnly"
                  @click="filterTask"
                  >Go</vs-button
                >
                <vs-tooltip color="primary" text="Reset" position="top">
                  <vs-button
                    @click="resetFilter"
                    type="border"
                    icon-pack="feather"
                    icon="icon-refresh-ccw"
                    class="ml-2"
                  ></vs-button>
                </vs-tooltip>
                <vs-tooltip
                  v-if="kanbanShow"
                  color="primary"
                  text="Live Task"
                  position="top"
                >
                  <vs-button
                    type="border"
                    class="includeIcon includeIconOnly ml-2"
                    @click="kanbanview"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 48 48"
                      fill="none"
                    >
                      <rect width="48" height="48" fill="white"></rect>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6 11.5C6 10.1193 7.11929 9 8.5 9H10.5C11.8807 9 13 10.1193 13 11.5C13 12.8807 11.8807 14 10.5 14H8.5C7.11929 14 6 12.8807 6 11.5Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6 23.5C6 22.1193 7.11929 21 8.5 21H10.5C11.8807 21 13 22.1193 13 23.5C13 24.8807 11.8807 26 10.5 26H8.5C7.11929 26 6 24.8807 6 23.5Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6 35.5C6 34.1193 7.11929 33 8.5 33H10.5C11.8807 33 13 34.1193 13 35.5C13 36.8807 11.8807 38 10.5 38H8.5C7.11929 38 6 36.8807 6 35.5Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M18 11.5C18 10.1193 19.1193 9 20.5 9L40.5 9C41.8807 9 43 10.1193 43 11.5C43 12.8807 41.8807 14 40.5 14L20.5 14C19.1193 14 18 12.8807 18 11.5Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M18 23.5C18 22.1193 19.1193 21 20.5 21L40.5 21C41.8807 21 43 22.1193 43 23.5C43 24.8807 41.8807 26 40.5 26L20.5 26C19.1193 26 18 24.8807 18 23.5Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M18 35.5C18 34.1193 19.1193 33 20.5 33L40.5 33C41.8807 33 43 34.1193 43 35.5C43 36.8807 41.8807 38 40.5 38L20.5 38C19.1193 38 18 36.8807 18 35.5Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                    </svg>
                  </vs-button>
                </vs-tooltip>
                <vs-tooltip v-else color="primary" text="Kanban" position="top">
                  <vs-button
                    type="border"
                    class="includeIcon includeIconOnly ml-2"
                    @click="kanbanview"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 48 48"
                      fill="none"
                    >
                      <rect width="48" height="48" fill="white"></rect>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M41 5H7C5.89543 5 5 5.89543 5 7V41C5 42.1046 5.89543 43 7 43H41C42.1046 43 43 42.1046 43 41V7C43 5.89543 42.1046 5 41 5ZM7 3C4.79086 3 3 4.79086 3 7V41C3 43.2091 4.79086 45 7 45H41C43.2091 45 45 43.2091 45 41V7C45 4.79086 43.2091 3 41 3H7Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16 44L16 4L18 4L18 44L16 44Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M30 44L30 4L32 4L32 44L30 44Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7 8C7 7.44772 7.44772 7 8 7H13C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9H8C7.44772 9 7 8.55228 7 8Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20 8C20 7.44772 20.4477 7 21 7H26C26.5523 7 27 7.44772 27 8C27 8.55228 26.5523 9 26 9H21C20.4477 9 20 8.55228 20 8Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M34 8C34 7.44772 34.4477 7 35 7H40C40.5523 7 41 7.44772 41 8C41 8.55228 40.5523 9 40 9H35C34.4477 9 34 8.55228 34 8Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9 13V16H12V13H9ZM8 11C7.44772 11 7 11.4477 7 12V17C7 17.5523 7.44772 18 8 18H13C13.5523 18 14 17.5523 14 17V12C14 11.4477 13.5523 11 13 11H8Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M22 13V16H25V13H22ZM21 11C20.4477 11 20 11.4477 20 12V17C20 17.5523 20.4477 18 21 18H26C26.5523 18 27 17.5523 27 17V12C27 11.4477 26.5523 11 26 11H21Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M36 13V16H39V13H36ZM35 11C34.4477 11 34 11.4477 34 12V17C34 17.5523 34.4477 18 35 18H40C40.5523 18 41 17.5523 41 17V12C41 11.4477 40.5523 11 40 11H35Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9 24V27H12V24H9ZM8 22C7.44772 22 7 22.4477 7 23V28C7 28.5523 7.44772 29 8 29H13C13.5523 29 14 28.5523 14 28V23C14 22.4477 13.5523 22 13 22H8Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M22 24V27H25V24H22ZM21 22C20.4477 22 20 22.4477 20 23V28C20 28.5523 20.4477 29 21 29H26C26.5523 29 27 28.5523 27 28V23C27 22.4477 26.5523 22 26 22H21Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M22 35V38H25V35H22ZM21 33C20.4477 33 20 33.4477 20 34V39C20 39.5523 20.4477 40 21 40H26C26.5523 40 27 39.5523 27 39V34C27 33.4477 26.5523 33 26 33H21Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M36 24V27H39V24H36ZM35 22C34.4477 22 34 22.4477 34 23V28C34 28.5523 34.4477 29 35 29H40C40.5523 29 41 28.5523 41 28V23C41 22.4477 40.5523 22 40 22H35Z"
                        fill="rgba(var(--vs-primary), 1)"
                      ></path>
                    </svg>
                  </vs-button>
                </vs-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-card>

      <vs-card class="cstm_vx_card mb-4" v-if="projects">
        <div slot="header" class="flex justify-between">
          <h4>Select View</h4>
        </div>
        <vs-row>
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-row>
              <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
                <vs-input
                  placeholder="Search"
                  class="w-full"
                  v-model="searchProject"
                  @keyup="searchFun"
                  style="width: 100%"
                />
              </vs-col>
              <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
                <date-range-picker
                  class="w-full cstm_daterangepicker h-full"
                  ref="picker"
                  :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm' }"
                  :showWeekNumbers="true"
                  :showDropdowns="true"
                  :ranges="customDateRanges()"
                  v-model="dateRangeProject"
                >
                  <template v-slot:input="picker" style="min-width: 350px">
                    <span
                      v-if="
                        dateRangeProject.startDate === '' ||
                          dateRangeProject.endDate === ''
                      "
                      style="
                        color: rgba(0, 0, 0, 0.5);
                        font-weight: 400;
                        font-size: 12px;
                      "
                      >Select Date Range</span
                    >
                    <span v-else
                      >{{ picker.startDate | date }} -
                      {{ picker.endDate | date }}</span
                    >
                  </template>
                </date-range-picker>
              </vs-col>
              <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
                <vs-input
                  class="w-full"
                  type="number"
                  v-model="no_of_tasks"
                  placeholder="No Of Task"
                ></vs-input>
              </vs-col>

              <vs-col
                vs-type="flex"
                vs-lg="3"
                vs-sm="12"
                vs-xs="12"
                class="p-1"
              >
                <vs-button
                  class="includeIcon includeIconOnly"
                  @click="filterProject"
                  >Go</vs-button
                >
                <vs-tooltip color="primary" text="Reset" position="top">
                  <vs-button
                    @click="resetProjectFilter"
                    type="border"
                    icon-pack="feather"
                    icon="icon-refresh-ccw"
                    class="ml-2"
                  ></vs-button>
                </vs-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-card>
      <vs-card class="cstm_vx_card mb-4" v-if="template">
        <div slot="header" class="flex justify-between">
          <h4>Select View</h4>
        </div>
        <vs-row>
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-row>
              <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
                <vs-input
                  placeholder="Search"
                  class="w-full"
                  v-model="searchTemplate"
                  @keyup="searchFun"
                  style="width: 100%"
                />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-lg="3"
                vs-sm="12"
                vs-xs="12"
                class="p-1"
              >
                <vs-tooltip color="primary" text="Reset" position="top">
                  <vs-button
                    @click="resetTemplate"
                    type="border"
                    icon-pack="feather"
                    icon="icon-refresh-ccw"
                    class="ml-2"
                  ></vs-button>
                </vs-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-card>

      <div class="inner-cstm-tab-text">
        <div class="text-right" v-if="isRowSelected">
          <div class="bulk_holder">
            <a @click="handleBulkDelete"> Bulk Delete </a>
          </div>
        </div>
        <div v-if="template">
          <!-- <pre>{{meta_template_data}}</pre> -->
          <ag-grid-vue
            ref="agGridTable"
            :components="components"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :style="{ minHeight: meta_template_data.limit * 48 + 75 + 'px' }"
            :rowData="limitedTableList"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :floatingFilter="false"
            :pagination="true"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            @cell-value-changed="onCellValueChanged"
            @row-selected="CellvalueSelectDeselect"
            :enableRtl="$vs.rtl"
            @cell-clicked="cellSingleClicked"
            @grid-ready="onGridReady1"
            @sortChanged="sortFunTemplate"
          >
          </ag-grid-vue>
          <vs-row
            v-if="!kanbanShow && !projects && taskViewPermission"
            class="mt-2"
            vs-type="flex"
            vs-justify="space-between"
          >
            <vs-col
              vs-w="4"
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
            >
              <ItemsPerTableDropdown
                :tableName="task ? 'task_table' : 'task_template_table'"
                @change="pageLimit => (pageLimitSetTemplate = pageLimit)"
              />
            </vs-col>
            <vs-col v-if="template" vs-xs="12" vs-sm="6" vs-lg="8">
              <pagination
                style="float: right"
                :meta="meta_template_data"
                @page-change="handlePageChange"
              />
            </vs-col>
            <vs-col v-else vs-xs="12" vs-sm="6" vs-lg="8">
              <pagination
                style="float: right"
                :meta="meta_task_data"
                @page-change="handlePageChangeLive"
              />
            </vs-col>
          </vs-row>
        </div>
        <div v-if="task && taskViewPermission">
          <!-- <pre>{{meta_task_data}}</pre> -->
          <div v-if="!kanbanShow">
            <ag-grid-vue
              ref="agGridTable"
              :components="components"
              :gridOptions="gridOptions1"
              class="ag-theme-material w-100 ag-grid-table task-ag-grid"
              :columnDefs="columnDefs1"
              :defaultColDef="defaultColDef"
              :style="{ minHeight: meta_task_data.limit * 80 + 75 + 'px' }"
              :rowData="limitedTableLiveList"
              rowSelection="multiple"
              colResizeDefault="shift"
              :animateRows="true"
              :floatingFilter="false"
              :pagination="true"
              :paginationPageSize="paginationPageSize"
              :suppressPaginationPanel="true"
              @cell-value-changed="onCellValueChanged"
              @row-selected="CellvalueSelectDeselect2"
              :enableRtl="$vs.rtl"
              @cell-clicked="cellSingleClickedLive"
              @grid-ready="onGridReady2"
              @sortChanged="sortFun"
            >
            </ag-grid-vue>
            <vs-row
              v-if="!kanbanShow && !projects && taskViewPermission"
              class="mt-2"
              vs-type="flex"
              vs-justify="space-between"
            >
              <vs-col
                vs-w="4"
                vs-type="flex"
                vs-justify="start"
                vs-align="center"
              >
                <ItemsPerTableDropdown
                  :tableName="task ? 'task_table' : 'task_template_table'"
                  @change="pageLimit => (pageLimitSet = pageLimit)"
                />
              </vs-col>
              <vs-col v-if="template" vs-xs="12" vs-sm="6" vs-lg="8">
                <pagination
                  style="float: right"
                  :meta="meta_template_data"
                  @page-change="handlePageChange"
                />
              </vs-col>
              <vs-col v-else vs-xs="12" vs-sm="6" vs-lg="8">
                <pagination
                  style="float: right"
                  :meta="meta_task_data"
                  @page-change="handlePageChangeLive"
                />
              </vs-col>
            </vs-row>
          </div>
          <!-- <vs-button v-if="kanbanShow"  @click="kanbanview" class="kanban">Live Task</vs-button>
            <vs-button v-else @click="kanbanview" class="kanban">Kanban</vs-button> -->
          <kanban
            v-if="kanbanShow"
            @openModalSectionLiveFromKanban="
              openModalSectionLiveFromKanban($event)
            "
            :liveData="UpdatedListOfLiveTask"
          ></kanban>
        </div>
        <div v-if="projects">
          <ProjectListing
            :filterDataList="ListOfProjectFilterData"
          ></ProjectListing>
        </div>
      </div>
    </div>
    <!-- <pagination v-if="kanbanShow" class="mt-2" :meta="meta_task" @page-change="handlePageChange" style="float:right"/> -->

    <vs-popup title="Warning" :active.sync="additionalPopUp">
      <h3>
        One or more tasks could not be deleted as they are referred somewhere
        else.
      </h3>
      <vs-list>
        <vs-list-item
          v-for="(item, index) in nonDeletableItems"
          :key="index"
          :title="item"
        ></vs-list-item>
      </vs-list>
    </vs-popup>
  </div>
</template>

<script>
import FullNameCell from './FullNameCell.vue'
import { AgGridVue } from 'ag-grid-vue'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from './CellRendererActions.vue'
import ReferenceAction from './ReferenceAction.vue'
import StatusCell from './statuscell'
import liveTaskStatusCell from './liveTaskStatusCell'
import liveTaskStatus from './liveTaskStatus'
import deadlineFormat from './deadline'
import kanban from './kanban-view.vue'
import Pagination from '@/components/common/pagination'
import {
  fetchUserClient,
  taskUpdate,
  taskTemplateUpdate,
  taskTemplateDelete,
  taskDelete,
  projectList
} from '@/api/task-project.js'
import { mapGetters, mapActions } from 'vuex'
import { Project } from '../mixins/project.js'
import ProjectListing from '../project-listing.vue'
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import vSelect from 'vue-select'

export default {
  name: 'task-table',
  components: {
    AgGridVue,
    CellRendererActions,
    ReferenceAction,
    StatusCell,
    liveTaskStatusCell,
    kanban,
    Pagination,
    liveTaskStatus,
    ProjectListing,
    DateRangePicker,
    vSelect,
    deadlineFormat,
    FullNameCell
  },
  props: [
    'UpdatedListOfLiveTask',
    'UpdatedListOfTask',
    'meta_template_data',
    'meta_task_data',
    'taskViewPermission',
    'projectViewPermission',
    'taskEditPermission',
    'checkProjectEditPermissionData',
    'checkProjectDeletePermissionData'
  ],
  mixins: [Project, PermissionMiddleware],
  data () {
    return {
      pageLimitSetTemplate: 5,
      pageLimitSet: 5,
      pageLimitProject: 5,
      search: '',
      searchProject: '',
      searchTemplate: '',
      gridOptions: {
        accentedSort: true
      },
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      sorting_objTemplate: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      clientListMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      clientList: [],
      userListMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      userList: [],
      liveTaskData2: this.UpdatedListOfLiveTask,
      taskData2: this.UpdatedListOfTask,
      isRowSelected: false,
      primary: '#41ddcc',
      kanbanShow: false,
      searchQuery: '',
      gridOptions1: {
        accentedSort: true
      },
      meta: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      filterNow: false,
      ListOfProjectFilterData: [],
      maxPageNumbers: 7,
      gridApi1: null,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true,
        autoHeight: true
      },
      components: {
        CellRendererActions,
        liveTaskStatus,
        ReferenceAction,
        StatusCell,
        liveTaskStatusCell,
        FullNameCell
      },
      columnDefs: [
        {
          headerName: '',
          width: 50,
          field: 'isSelected',
          filter: true,
          checkboxSelection: true,
          editable: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: '#',
          field: 'row_index',
          sortable: false,
          filter: true,
          width: 60,
          resizable: true,
          editable: false,
          valueGetter: params => {
            return (
              this.meta_template_data.limit *
                (this.meta_template_data.current_page - 1) +
              params.node.rowIndex +
              1
            )
          }
        },
        {
          headerName: 'Template Name',
          field: 'name',
          minWidth: 175,
          editable: false,
          filter: true,
          cellStyle: { color: 'blue', cursor: 'pointer' }
        },
        {
          headerName: 'Task Details',
          field: 'details',
          filter: true,
          editable: true,
          minWidth: 300
        },
        {
          headerName: 'Priority',
          field: 'task_priority.id',
          minWidth: 250,
          filter: true,
          cellRendererFramework: 'StatusCell',
          editable: false,
          comparator:(valueA) => {}

        },
        {
          headerName: 'Deadline',
          field: 'due_date',
          minWidth: 175,
          editable: false,
          filter: true,
          cellRendererFramework: 'deadlineFormat'
        },
        {
          headerName: 'Action',
          field: 'action',
          filter: false,
          editable: false,
          width: 100,
          cellRendererFramework: 'CellRendererActions',
          filterParams: { openModalSectionLive: this.openModalSection }
        }
      ],

      columnDefs1: [
        {
          headerName: '',
          minWidth: 50,
          field: 'isSelected',
          filter: true,
          checkboxSelection: true,
          editable: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: '#',
          field: 'row_index',
          sortable: false,
          filter: true,
          minWidth: 100,
          resizable: true,
          editable: false,
          valueGetter: params => {
            return (
              this.meta_task_data.limit *
                (this.meta_task_data.current_page - 1) +
              params.node.rowIndex +
              1
            )
          }
        },
        {
          headerName: 'Reference Id',
          field: 'reference_id',
          filter: true,
          minWidth: 150,
          resizable: true,
          editable: false,
          cellRendererFramework: 'ReferenceAction'
        },
        {
          headerName: 'Task Name',
          field: 'name',
          minWidth: 250,
          editable: false,
          filter: true,
          cellStyle: {
            'color': 'blue',
            'cursor': 'pointer',
            'white-space': 'normal',
            'word-break': 'break-word',
            'line-height': '20px'
          }
        },
        {
          headerName: 'Task Details',
          field: 'details',
          filter: true,
          editable: true,
          minWidth: 200
        },
        {
          headerName: 'Responsible Person',
          field: 'taskResponsiblePerson',
          filter: true,
          sortable: false,
          editable: true,
          minWidth: 200,
          cellRendererFramework: 'FullNameCell',
          suppressMovable: false
        },
        {
          headerName: 'Priority',
          field: 'task_priority.id',
          minWidth: 150,
          filter: true,
          cellRendererFramework: 'liveTaskStatusCell',
          editable: false,
          comparator:(valueA) => {}
        },
        {
          headerName: 'Status',
          field: 'status.id',
          minWidth: 150,
          filter: true,
          cellRendererFramework: 'liveTaskStatus',
          editable: false,
          comparator:(valueA) => {}
        },
        {
          headerName: 'Deadline',
          field: 'due_date',
          minWidth: 200,
          editable: false,
          filter: true,
          cellRendererFramework: 'deadlineFormat'
        },
        {
          headerName: 'Action',
          field: 'action',
          filter: false,
          editable: false,
          minWidth: 100,
          sortable: false,
          cellRendererFramework: 'CellRendererActions',
          filterParams: { openModalSectionLive: this.openModalSectionLive }
        }
      ],
      options: [
        { id: 1, status: 'To Do' },
        { id: 2, status: 'In Progress' },
        { id: 3, status: 'Done' }
      ],
      template: false,
      task: true,
      projects: false,
      dateRange: { startDate: '', endDate: '' },
      dateRangeProject: { startDate: '', endDate: '' },
      no_of_tasks: null,
      task_status_id: null,
      taskResponsiblePersonClientUser: null,
      taskResponsiblePersonUser: null,
      nonDeletableItems: [],
      additionalPopUp: false,
      query_page_user: {
        page: 1
      },
      query_page_client: {
        page: 1
      },
      observerUser: new IntersectionObserver(this.loadMoreUser),
      observerStudent: new IntersectionObserver(this.loadMoreClient)
    }
  },
  computed: {
    ...mapGetters([
      'get_task_deleted_id',
      'get_status_changes',
      'get_priority_changes',
      'get_priority_id',
      'get_status_id',
      'get_task_deleted_live_id',
      'get_task_added_id'
    ]),
    limitedTableList () {
      return this.UpdatedListOfTask
    },

    limitedTableLiveList () {
      return this.UpdatedListOfLiveTask
    }
  },
  watch: {
    get_task_deleted_id () {
      if (this.get_task_deleted_id) {
        const table = this.UpdatedListOfTask
        const dlt_id = table.findIndex(
          item => item.id === this.get_task_deleted_id
        )
        table.splice(dlt_id, 1)
        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.UpdatedListOfTask = table
        if (
          this.UpdatedListOfTask.length === 0 &&
          !this.meta_template_data.next_page_url
        ) {
          this.handlePageChange(this.meta_template_data.current_page - 1)
        } else {
          this.handlePageChange(this.meta_template_data.current_page)
        }
      }
    },
    get_priority_id () {
      if (this.get_priority_changes) {
        const table = this.UpdatedListOfLiveTask
        const dlt_id = table.findIndex(
          item => item.id === this.get_priority_changes
        )
        table[dlt_id].task_priority.id = this.get_priority_id
        this.UpdatedListOfLiveTask = table
      }
    },
    get_status_id () {
      if (this.get_status_changes) {
        const table = this.UpdatedListOfLiveTask
        const dlt_id = table.findIndex(
          item => item.id === this.get_status_changes
        )
        table[dlt_id].status.id = this.get_status_id
        this.UpdatedListOfLiveTask = table
      }
    },
    ListOfProjectFilterData () {
      console.log(this.ListOfProjectFilterData)
      this.ListOfProjectFilterData = this.ListOfProjectFilterData
    },
    pageLimitSet () {
      this.handlePageChangeLive(1)
    },
    pageLimitSetTemplate () {
      this.handlePageChange(1)
    },
    get_task_deleted_live_id () {
      if (this.get_task_deleted_live_id) {
        const table = this.UpdatedListOfLiveTask
        const dlt_id = table.findIndex(
          item => item.id === this.get_task_deleted_live_id
        )
        table.splice(dlt_id, 1)
        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.UpdatedListOfLiveTask = table
        if (
          this.UpdatedListOfLiveTask.length === 0 &&
          !this.meta_task_data.next_page_url
        ) {
          this.handlePageChangeLive(this.meta_task_data.current_page - 1)
        } else {
          this.handlePageChangeLive(this.meta_task_data.current_page)
        }
      }
    }
  },
  created () {
    this.tab(this.$route.params.tab)
  },
  mounted () {
    const payload = {
      source: true
    }
    fetchUserClient(
      'User',
      localStorage.getItem('customer_id'),
      this.query_page_user,
      payload
    )
      .then(res => {
        this.userList = res.data.data.users_list
        this.userList = this.userList.map(user => {
          user.label = `${user.first_name} ${user.last_name}`
          return user
        })
        this.userListMeta = res.data.data.meta
      })
      .catch(e => {})
    fetchUserClient(
      'Client',
      localStorage.getItem('customer_id'),
      this.query_page_client
    )
      .then(res => {
        this.clientList = res.data.data.users_list
        this.clientList = this.clientList.map(user => {
          user.label = `${user.first_name} ${user.last_name}`
          return user
        })
        this.clientListMeta = res.data.data.meta
      })
      .catch(e => {})
    if (this.projectViewPermission && !this.taskViewPermission) {
      this.tab('projects')
    }
    if (Object.keys(this.$route.params).length !== 0) {
      if (
        Object.keys(this.$route.params.payload).length !== 0 &&
        this.$route.params.payload.constructor === Object
      ) {
        if (this.$route.params.payload.project === true) {
          this.projects = this.$route.params.payload.project
          this.template = false
          this.task = false
        } else if (this.$route.params.payload.template === true) {
          this.template = this.$route.params.payload.template
          this.task = false
        } else {
          this.task = this.$route.params.payload.livetask
          this.template = false
        }
      }
    }
    this.gridApi = this.gridOptions.api
    this.gridApi1 = this.gridOptions1.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        '.ag-header-container'
      )
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`
    }
  },
  methods: {
    ...mapActions([
      'SET_DELETE_ID',
      'SET_DELETE_LIVE_ID',
      'SET_ADD_ID',
      'SET_STATUS',
      'SET_STATUS_ID',
      'SET_PRIORITY',
      'SET_PRIORITY_ID'
    ]),
    resetTemplate () {
      this.searchTemplate = ''
      this.handlePageChange(1)
    },
    getCorrectFieldName (colId) {
      let field_name = colId
      if (colId == 'task_priority.id') {
        field_name = 'priority'
      } else if (colId == 'status.id') {
        field_name = 'status'
      }
      return field_name
    },
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async vm => {
      if (vm.task) {
        let queryPayload = Object.assign({}, vm.$route.query)
        queryPayload.limit = vm.pageLimitSet
        queryPayload = { ...queryPayload, ...vm.sorting_obj }
        queryPayload.search = vm.search
        vm.$emit('passEventFilterTask', queryPayload)
        await vm.handlePageChangeLive(1)
      } else if (vm.projects) {
        await vm.filterProject()
      } else {
        await vm.handlePageChange(1)
      }
    }, 1500),
    async sortFun () {
      try {
        const sortState = this.gridOptions1.api.getSortModel()
        if (sortState.length == 0) {
          this.sorting_obj.field_type = ''
          this.sorting_obj.attribute = ''
          this.sorting_obj.direction = ''
          this.handlePageChangeLive(this.meta_task_data.current_page)
        } else {
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = this.getCorrectFieldName(
            sortState[0].colId
          )
          //this.sorting_obj.attribute= sortState[0].colId
          this.sorting_obj.direction = sortState[0].sort
          this.handlePageChangeLive(this.meta_task_data.current_page)
        }
      } catch (e) {}
    },
    async sortFunTemplate () {
      try {
        const sortState = this.gridOptions.api.getSortModel()
        if (sortState.length == 0) {
          console.log('No sort active')
          this.sorting_objTemplate = {
            field_type: '',
            attribute: '',
            direction: ''
          }

          this.handlePageChange(this.meta_template_data.current_page)
        } else {
          this.sorting_objTemplate.field_type = 'system'
          this.sorting_objTemplate.attribute = this.getCorrectFieldName(
            sortState[0].colId
          )
          //this.sorting_obj.attribute= sortState[0].colId
          this.sorting_objTemplate.direction = sortState[0].sort
          this.handlePageChange(this.meta_template_data.current_page)
        }
      } catch (e) {}
    },
    async loadMoreUser ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        console.log(this.userListMeta.current_page + 1)
        const payload = {
          source: true
        }
        try {
          const res = await fetchUserClient(
            'User',
            localStorage.getItem('customer_id'),
            { page: this.userListMeta.current_page + 1 },
            payload
          )
          this.userList.push(...res.data.data.users_list)
          this.userList = this.userList.map(user => {
            user.label = `${user.first_name} ${user.last_name}`
            return user
          })
          this.userListMeta = res.data.data.meta
        } catch (e) {}
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async onOpenUser () {
      if (this.userListMeta.has_next) {
        await this.$nextTick()
        this.observerUser.observe(this.$refs.load)
      }
    },
    onCloseUser () {
      this.observerUser.disconnect()
    },
    async loadMoreClient ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        const payload = {
          source: true
        }
        try {
          const res = await fetchUserClient(
            'Client',
            localStorage.getItem('customer_id'),
            { page: this.clientListMeta.current_page + 1 },
            payload
          )
          this.clientList.push(...res.data.data.users_list)
          this.clientList = this.clientList.map(user => {
            user.label = `${user.first_name} ${user.last_name}`
            return user
          })

          this.clientListMeta = res.data.data.meta
        } catch (e) {}

        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async onOpen () {
      if (this.clientListMeta.has_next) {
        await this.$nextTick()
        this.observerStudent.observe(this.$refs.loadStudent)
      }
    },
    onClose () {
      this.observerStudent.disconnect()
    },
    onGridReady1 () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    onGridReady2 () {
      this.gridOptions1.api.sizeColumnsToFit()
    },
    openCreate () {
      const QueryParams = {
        projectId: 0,
        project: false
      }
      this.$router
        .push({
          name: 'tasks-project-create',
          params: { payload: QueryParams }
        })
        .catch(() => {})
    },
    resetFilter () {
      this.search = ''
      this.dateRange.startDate = ''
      this.dateRange.endDate = ''
      this.dateRangeProject.startDate = ''
      this.dateRangeProject.endDate = ''
      this.task_status_id = null
      this.taskResponsiblePersonClientUser = null
      this.taskResponsiblePersonUser = null
      this.no_of_tasks = null
      this.filterNow = false
      this.handlePageChangeLive(1)
    },
    resetProjectFilter () {
      this.searchProject = ''
      this.dateRangeProject.startDate = ''
      this.dateRangeProject.endDate = ''
      this.no_of_tasks = null
      const queryPayloadString = Object.assign({}, this.$route.query)
      queryPayloadString.current_page = 1
      queryPayloadString.limit = this.pageLimitProject
      this.fetchProjectFilter(queryPayloadString)
    },
    kanbanview () {
      this.kanbanShow = !this.kanbanShow
    },
    tab (type) {
      // this.handlePageChange(1)
      if (type === 'template') {
        this.template = true
        this.task = false
        this.projects = false
        this.$emit('type1', 'Template')
      } else if (type === 'task') {
        this.template = false
        this.task = true
        this.projects = false
        this.$emit('type1', 'Tasks')
      } else if (type === 'projects') {
        this.template = false
        this.task = false
        this.projects = true
        this.$emit('type1', 'Projects')
      }
    },

    openModalSection (params) {
      if (this.taskEditPermission) {
        this.$emit('openModalSection', params)
      }
    },

    cellSingleClicked (params) {
      if (params.column.colId === 'name') {
        this.openModalSection(params)
      }
    },
    openModalSectionLive (params) {
      if (this.taskEditPermission) {
        this.$emit('openModalSectionLive', params)
      }
    },
    openModalSectionLiveFromKanban (params) {
      this.openModalSectionLive(params)
    },

    cellSingleClickedLive (params) {
      console.log(params)
      if (params.column.colId === 'name') {
        this.openModalSectionLive(params.data)
      }
    },
    handlePageChangeLive (page) {
      let queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      queryPayload.limit = this.pageLimitSet
      queryPayload = { ...queryPayload, ...this.sorting_obj }

      const pageScroll = document.documentElement.scrollTop
      this.$router
        .replace({ path: '/pages/tasks-project', query: queryPayload })
        .catch(() => {})
        .then(() => {
          document.documentElement.scrollTop = pageScroll
        })
      if (this.search !== '') {
        queryPayload.search = this.search
        this.$emit('passEventFilterTask', queryPayload)
      } else if (this.sorting_obj.attribute !== '') {
        queryPayload.table_name = 'task_table'
        this.passEventLive(queryPayload)
      } else if (this.filterNow === true) {
        this.filterTask(page)
      } else {
        this.passEventLive(queryPayload)
      }
    },
    handlePageChange (page) {
      let queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      queryPayload.limit = this.pageLimitSetTemplate
      const pageScroll = document.documentElement.scrollTop
      this.$router
        .replace({ path: '/pages/tasks-project', query: queryPayload })
        .catch(() => {})
        .then(() => {
          document.documentElement.scrollTop = pageScroll
        })
      queryPayload.table_name = 'task_template_table'
      queryPayload = { ...queryPayload, ...this.sorting_objTemplate }
      if (this.searchTemplate != '') {
        queryPayload.page = 1
        queryPayload.search = this.searchTemplate
        this.$emit('passTempEvent', queryPayload)
      } else {
        this.passEvent(queryPayload)
      }
    },
    passEventLive (page) {
      this.$emit('passEventLive', page)
    },
    passEventFilterTask (data) {
      console.log(data)
      this.filterNow = true
      this.$emit('passEventFilterTask', data)
    },
    passEventFilterProject (data) {
      this.$emit('passEventFilterProject', data)
    },
    passEvent (page) {
      this.$emit('passEvent', page)
    },
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      //
      if (selectedNodes) {
        const selecttedNode = this.gridApi.getSelectedNodes()
        const selectedRows = selecttedNode.map(node => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },
    CellvalueSelectDeselect2 () {
      this.gridApi1 = this.gridOptions1.api
      const selectedNodes = this.gridApi1.getSelectedNodes()
      //
      if (selectedNodes) {
        const selecttedNode = this.gridApi1.getSelectedNodes()
        const selectedRows = selecttedNode.map(node => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },

    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      return selectedData
    },
    getSelectedRows2 () {
      const selectedNodes = this.gridApi1.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      return selectedData
    },

    onCellValueChanged (params) {
      if (this.taskEditPermission) {
        if (this.task === true) {
          const data = []
          data.colId = params.column.getId()
          data.task_id = params.data.id
          if (data.colId === 'name') {
            data.fieldvalue = params.data.name
            data.colId = 'name'
            if (data.fieldvalue === '') {
              this.$vs.notify({
                title: 'Warning',
                text: 'Name field must be greater than 0',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                time: 8000
              })
              return false
            }
          } else if (data.colId === 'details') {
            data.fieldvalue = params.data.details
            data.colId = 'details'
            // if (data.fieldvalue === '') {
            //   this.$vs.notify({
            //     title: 'Warning',
            //     text: 'Details field must be greater than 0',
            //     iconPack: 'feather',
            //     icon: 'icon-alert-circle',
            //     color: 'warning',
            //     time: 8000
            //   })
            //   return false
            // }
          }
          this.update_user(data)
        } else {
          const data = []
          data.colId = params.column.getId()
          data.task_id = params.data.id

          if (data.colId === 'name') {
            data.fieldvalue = params.data.name
            data.colId = 'name'
            if (data.fieldvalue === '') {
              this.$vs.notify({
                title: 'Warning',
                text: 'Name field must be greater than 0',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                time: 8000
              })
              return false
            }
          } else if (data.colId === 'details') {
            data.fieldvalue = params.data.details
            data.colId = 'details'
            // if (data.fieldvalue === '') {
            //   this.$vs.notify({
            //     title: 'Warning',
            //     text: 'Details field must be greater than 0',
            //     iconPack: 'feather',
            //     icon: 'icon-alert-circle',
            //     color: 'warning',
            //     time: 8000

            //   })
            //   return false
            // }
          }
          this.update_user(data)
        }
      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'Sorry! you don\'t have permission to edit',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 8000
        })
      }
    },
    async update_user (data) {
      if (this.task === true) {
        const task_id = data.task_id
        const payload = {
          updateField: {
            [data.colId]: data.fieldvalue
          }
        }
        try {
          const { data } = await taskUpdate(
            localStorage.getItem('customer_id'),
            task_id,
            payload
          )

          this.$vs.notify({
            title: 'Success',
            text: 'Task Updated Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        } catch (api_error) {
          this.$vs.notify({
            title: 'Warning',
            text: api_error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
        }
      } else {
        const task_id = data.task_id
        const payload = {
          updateField: {
            [data.colId]: data.fieldvalue
          }
        }
        try {
          const { data } = await taskTemplateUpdate(
            localStorage.getItem('customer_id'),
            task_id,
            payload
          )

          this.$vs.notify({
            title: 'Success',
            text: 'Task Updated Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        } catch (api_error) {
          this.$vs.notify({
            title: 'Warning',
            text: api_error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
        }
      }
    },

    handleBulkDelete () {
      if (this.task === true) {
        const BulkSelected = this.getSelectedRows2()
        const deleting_ids = []
        for (let i = 0; i < BulkSelected.length; i++) {
          deleting_ids.push(BulkSelected[i].id)
        }
        const payload = {
          deleteFields: deleting_ids
        }
        taskDelete(localStorage.getItem('customer_id'), payload)
          .then(response => {
            if (response.status === 200 || response.status === 202) {
              if (response.data.data.status) {
                this.additionalPopUp = true
                this.nonDeletableItems = response.data.data.nonDeletableEntity.map(
                  item => {
                    return item.name
                  }
                )
              } else {
                const table = this.UpdatedListOfLiveTask
                for (const delete_id_itr of deleting_ids) {
                  for (let i = 0; i < table.length; i++) {
                    if (delete_id_itr === table[i].id) {
                      table.splice(i, 1)
                    }
                  }
                }
                table.map((row, index) => {
                  row.row_index = index + 1
                })
                this.UpdatedListOfLiveTask = table
                this.isRowSelected = true
                console.log(this.meta_task_data)
                if (
                  this.UpdatedListOfLiveTask.length === 0 &&
                  !this.meta_task_data.next_page_url
                ) {
                  this.handlePageChangeLive(
                    this.meta_task_data.current_page - 1
                  )
                } else {
                  this.handlePageChangeLive(this.meta_task_data.current_page)
                }

                this.$vs.notify({
                  title: 'Success',
                  text: 'Bulk Deletion Successfull',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success'
                })
              }
            }
          })
          .catch(e => {
            this.$vs.notify({
              title: 'Warning',
              text: e.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          })
      } else {
        const BulkSelected = this.getSelectedRows()
        const deleting_ids = []
        for (let i = 0; i < BulkSelected.length; i++) {
          deleting_ids.push(BulkSelected[i].id)
        }
        const payload = {
          deleteFields: deleting_ids
        }
        taskTemplateDelete(localStorage.getItem('customer_id'), payload)
          .then(data => {
            const table = this.UpdatedListOfTask
            for (const delete_id_itr of deleting_ids) {
              for (let i = 0; i < table.length; i++) {
                if (delete_id_itr === table[i].id) {
                  table.splice(i, 1)
                }
              }
            }
            table.map((row, index) => {
              row.row_index = index + 1
            })
            this.UpdatedListOfTask = table
            if (
              this.UpdatedListOfTask.length === 0 &&
              !this.meta_template_data.next_page_url
            ) {
              this.handlePageChange(this.meta_template_data.current_page - 1)
            } else {
              this.handlePageChange(this.meta_template_data.current_page)
            }
            this.isRowSelected = true
            this.$vs.notify({
              title: 'Success',
              text: 'Bulk Deletion Successfull',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
          })
          .catch(e => {
            this.$vs.notify({
              title: 'Warning',
              text: e.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          })
      }
    },
    filterTask (page = 1) {
      const payload = {}
      if (this.dateRange.startDate !== '' && this.dateRange.endDate !== '') {
        payload.startDate = this.$moment(this.dateRange.startDate).format(
          'YYYY-MM-DD'
        )
        payload.endDate = this.$moment(this.dateRange.endDate).format(
          'YYYY-MM-DD'
        )
        payload.task_status_id = this.task_status_id
        payload.taskResponsiblePersonClientUser = this.taskResponsiblePersonClientUser
        payload.taskResponsiblePersonUser = this.taskResponsiblePersonUser
        payload.limit = this.pageLimitSet
        payload.page = page
      } else if (
        this.dateRange.startDate !== '' &&
        this.dateRange.endDate === ''
      ) {
        payload.startDate = this.$moment(this.dateRange.startDate).format(
          'YYYY-MM-DD'
        )
        payload.task_status_id = this.task_status_id
        payload.taskResponsiblePersonClientUser = this.taskResponsiblePersonClientUser
        payload.taskResponsiblePersonUser = this.taskResponsiblePersonUser
        payload.limit = this.pageLimitSet
        payload.page = page
      } else if (
        this.dateRange.startDate === '' &&
        this.dateRange.endDate !== ''
      ) {
        payload.endDate = this.$moment(this.dateRange.endDate).format(
          'YYYY-MM-DD'
        )
        payload.task_status_id = this.task_status_id
        payload.taskResponsiblePersonClientUser = this.taskResponsiblePersonClientUser
        payload.taskResponsiblePersonUser = this.taskResponsiblePersonUser
        payload.limit = this.pageLimitSet
        payload.page = page
      } else {
        payload.startDate = this.dateRange.startDate
        payload.endDate = this.dateRange.endDate
        payload.task_status_id = this.task_status_id
        payload.taskResponsiblePersonClientUser = this.taskResponsiblePersonClientUser
        payload.taskResponsiblePersonUser = this.taskResponsiblePersonUser
        payload.limit = this.pageLimitSet
        payload.page = page
      }
      console.log(page)
      this.passEventFilterTask(payload)
    },
    filterProject () {
      const payload = {}
      if (
        this.dateRangeProject.startDate !== '' &&
        this.dateRangeProject.endDate !== ''
      ) {
        payload.startDate = this.$moment(
          this.dateRangeProject.startDate
        ).format('YYYY-MM-DD')
        payload.endDate = this.$moment(this.dateRangeProject.endDate).format(
          'YYYY-MM-DD'
        )
        payload.no_of_tasks = this.no_of_tasks
      } else if (
        this.dateRangeProject.startDate !== '' &&
        this.dateRangeProject.endDate === ''
      ) {
        payload.startDate = this.$moment(
          this.dateRangeProject.startDate
        ).format('YYYY-MM-DD')
        payload.no_of_tasks = this.no_of_tasks
      } else if (
        this.dateRangeProject.startDate === '' &&
        this.dateRangeProject.endDate !== ''
      ) {
        payload.endDate = this.$moment(this.dateRangeProject.endDate).format(
          'YYYY-MM-DD'
        )
        payload.no_of_tasks = this.no_of_tasks
      } else {
        payload.startDate = this.dateRangeProject.startDate
        payload.endDate = this.dateRangeProject.endDate
        payload.no_of_tasks = this.no_of_tasks
      }
      if (this.searchProject != '') {
        payload.search = this.searchProject
      }
      const queryPayloadString = Object.assign({}, this.$route.query)
      queryPayloadString.current_page = 1
      queryPayloadString.limit = this.pageLimitSet
      this.fetchProjectFilter(queryPayloadString, payload)
    },
    async fetchProjectFilter (query, filterData = null) {
      try {
        this.$vs.loading({
          type: 'radius'
        })
        if (!filterData) {
          const filterData = {}
          filterData.limit = this.pageLimitProject
          filterData.table_name = 'project_table'
        }

        const { data } = await projectList(
          localStorage.getItem('customer_id'),
          query,
          filterData
        )
        const table = data.data.project
        this.meta = data.data.meta
        table.map((row, index) => {
          const row_index = index + 1
          const checkProjectEditPermission = this
            .checkProjectEditPermissionData
          const checkProjectDeletePermission = this
            .checkProjectDeletePermissionData
          Object.assign(row, { row_index })
          Object.assign(row, { checkProjectEditPermission })
          Object.assign(row, { checkProjectDeletePermission })
        })
        this.$vs.loading.close()
        this.ListOfProjectFilterData = table
      } catch (e) {
        this.$vs.loading.close()
      }
    }
  }
}
</script>

<style>
.ag-theme-material {
  min-height: 300px;
}
.ag-theme-material.task-ag-grid .ag-ltr .ag-cell {
  display: flex;
  align-items: center;
}
.disableTabName .tab-name.disableTab {
  visibility: hidden;
}
.vue-daterange-picker.h-full .form-control {
  height: 100%;
}
</style>
